export const formatDate = (dateString?: string) => {
  if (!dateString) {
    return ''
  }
  const date = new Date(dateString)
  return date.toISOString().split('T')[0]
}



export const formatDateTime = (dateString?: string | number | Date) => {
  if (!dateString) return { formattedDate: '', formattedTime: '' }

  const date =
    typeof dateString === 'string'
      ? new Date(dateString.replace(/(am|pm)$/i, ' $1')) // Normalize string
      : new Date(dateString)

  if (isNaN(date.getTime())) return { formattedDate: '', formattedTime: '' }

  const formattedDate = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(date)

  const formattedTime = new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date)

  return { formattedDate, formattedTime }
}

// Helper function to format date
export const formatedDate = (dateString: string | undefined): string => {
  if (!dateString) return 'N/A'
  
  try {
    const date = new Date(dateString)
    
    // Check if date is valid
    if (isNaN(date.getTime())) return 'N/A'
    
    // Get day abbreviation
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const dayAbbreviation = days[date.getDay()]
    
    // Format date: MM/DD/YYYY
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const year = date.getFullYear()
    const formattedDate = `${month}/${day}/${year}`
    
    // Format time: hh:mm am/pm
    let hours = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours ? hours : 12 // 0 should be converted to 12
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes}${ampm}`
    
    return `${dayAbbreviation}, ${formattedDate}. ${formattedTime}`
  } catch (error) {
    console.error('Error formatting date:', error)
    return 'N/A'
  }
}

export const calculateValidityDate = (
  enabledAt: string | undefined,
  duration: string | undefined,
) => {
  if (!enabledAt || !duration) return 'NIL'

  const date = new Date(enabledAt)

  switch (duration.toUpperCase()) {
    case 'MONTHLY':
      date.setMonth(date.getMonth() + 1)
      break

    case 'QUARTERLY':
      date.setMonth(date.getMonth() + 3)
      break

    case 'HALF_YEARLY':
      date.setMonth(date.getMonth() + 6)
      break

    case 'ANNUALLY':
      date.setFullYear(date.getFullYear() + 1)
      break

    case 'INDEFINITELY':
      return 'Indefinitely'

    default:
      return 'NIL'
  }

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export const calculateLevyPeriod = (
  enabledAt?: string,
  duration?: string,
) => {
  if (!enabledAt || !duration) {
    return 'N/A'
  }

  const startDate = new Date(enabledAt)

  if (Number.isNaN(startDate.getTime())) {
    return 'N/A'
  }

  const startMonth = startDate.getMonth()
  const startYear = startDate.getFullYear()

  const monthName = (month: number) =>
    new Date(2000, month, 1).toLocaleString('en-US', {
      month: 'long',
    })

  let endMonth = startMonth
  let endYear = startYear

  switch (duration.toUpperCase()) {
    case 'MONTHLY':
      endMonth = startMonth
      endYear = startYear
      break

    case 'QUARTERLY':
      endMonth = startMonth + 2
      endYear = startYear
      break

    case 'HALF_YEARLY':
      endMonth = startMonth + 5
      endYear = startYear
      break

    case 'ANNUALLY':
      endMonth = startMonth + 11
      endYear = startYear
      break

    case 'INDEFINITELY':
      return `${monthName(startMonth)} ${startYear} - Indefinitely`

    default:
      return `${monthName(startMonth)} ${startYear}`
  }

  const endDate = new Date(endYear, endMonth, 1)

  endMonth = endDate.getMonth()
  endYear = endDate.getFullYear()

  if (startMonth === endMonth && startYear === endYear) {
    return `${monthName(startMonth)} ${startYear}`
  }

  return `${monthName(startMonth)} - ${monthName(endMonth)} ${endYear}`
}